const updateChipFeed = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response') {
        if (datasource === 'gumbo') {
            const liveData = action.data?.liveData;
            const currentPlay = action?.data?.liveData?.plays?.currentPlay;
            const inningState = liveData?.linescore?.inningState || 'Top';
            const isEndOrMid = inningState === 'Middle' || inningState === 'End';
            return {
                ...state,
                currentPlay,
                isEndOrMid
            };
        }
    }

    return state;
};

export default updateChipFeed;
